

export enum EnumNovelSiteList
{
	NovelSiteAlphapolis = 'alphapolis',
	NovelSiteDemoBase = 'demo/base',
	NovelSiteDemoDemo = 'demo/demo',
	NovelSiteDemoTree = 'demo/tree',
	NovelSiteDmzjApi = 'dmzj/api',
	NovelSiteDmzj = 'dmzj',
	NovelSiteEsjzone = 'esjzone',
	NovelSiteHetubook = 'hetubook',
	NovelSiteIqing = 'iqing',
	NovelSiteKakuyomu = 'kakuyomu',
	NovelSiteMillionbook = 'millionbook',
	NovelSiteNovelba = 'novelba',
	NovelSiteNovelup = 'novelup',
	NovelSiteSfacg = 'sfacg',
	NovelSiteSyosetu = 'syosetu',
	NovelSiteUukanshu = 'uukanshu',
	NovelSiteWebqxs = 'webqxs',
	NovelSiteWenku8 = 'wenku8',
	NovelSiteX23qb = 'x23qb',
	'alphapolis' = 'alphapolis',
	'demo/base' = 'demo/base',
	'demo/demo' = 'demo/demo',
	'demo/tree' = 'demo/tree',
	'dmzj/api' = 'dmzj/api',
	'dmzj' = 'dmzj',
	'esjzone' = 'esjzone',
	'hetubook' = 'hetubook',
	'iqing' = 'iqing',
	'kakuyomu' = 'kakuyomu',
	'millionbook' = 'millionbook',
	'novelba' = 'novelba',
	'novelup' = 'novelup',
	'sfacg' = 'sfacg',
	'syosetu' = 'syosetu',
	'uukanshu' = 'uukanshu',
	'webqxs' = 'webqxs',
	'wenku8' = 'wenku8',
	'x23qb' = 'x23qb',
	'./site/alphapolis' = 'alphapolis',
	'./site/demo/base' = 'demo/base',
	'./site/demo/demo' = 'demo/demo',
	'./site/demo/tree' = 'demo/tree',
	'./site/dmzj/api' = 'dmzj/api',
	'./site/dmzj' = 'dmzj',
	'./site/esjzone' = 'esjzone',
	'./site/hetubook' = 'hetubook',
	'./site/iqing' = 'iqing',
	'./site/kakuyomu' = 'kakuyomu',
	'./site/millionbook' = 'millionbook',
	'./site/novelba' = 'novelba',
	'./site/novelup' = 'novelup',
	'./site/sfacg' = 'sfacg',
	'./site/syosetu' = 'syosetu',
	'./site/uukanshu' = 'uukanshu',
	'./site/webqxs' = 'webqxs',
	'./site/wenku8' = 'wenku8',
	'./site/x23qb' = 'x23qb',
}

export type EnumNovelSiteListString = 'alphapolis' | 'demo/base' | 'demo/demo' | 'demo/tree' | 'dmzj/api' | 'dmzj' | 'esjzone' | 'hetubook' | 'iqing' | 'kakuyomu' | 'millionbook' | 'novelba' | 'novelup' | 'sfacg' | 'syosetu' | 'uukanshu' | 'webqxs' | 'wenku8' | 'x23qb';

export enum EnumIDKEYList
{
	NovelSiteAlphapolis = 'alphapolis',
	NovelSiteDmzjApi = 'dmzj',
	NovelSiteDmzj = 'dmzj',
	NovelSiteEsjzone = 'esjzone',
	NovelSiteHetubook = 'hetubook',
	NovelSiteIqing = 'iqing',
	NovelSiteKakuyomu = 'kakuyomu',
	NovelSiteMillionbook = 'millionbook',
	NovelSiteNovelba = 'novelba',
	NovelSiteNovelup = 'novelup',
	NovelSiteSfacg = 'sfacg',
	NovelSiteSyosetu = 'syosetu',
	NovelSiteUukanshu = 'uukanshu',
	NovelSiteWebqxs = 'webqxs',
	NovelSiteWenku8 = 'wenku8',
	NovelSiteX23qb = 'x23qb',
	'alphapolis' = 'alphapolis',
	'dmzj/api' = 'dmzj',
	'dmzj' = 'dmzj',
	'esjzone' = 'esjzone',
	'hetubook' = 'hetubook',
	'iqing' = 'iqing',
	'kakuyomu' = 'kakuyomu',
	'millionbook' = 'millionbook',
	'novelba' = 'novelba',
	'novelup' = 'novelup',
	'sfacg' = 'sfacg',
	'syosetu' = 'syosetu',
	'uukanshu' = 'uukanshu',
	'webqxs' = 'webqxs',
	'wenku8' = 'wenku8',
	'x23qb' = 'x23qb',
	'./site/alphapolis' = 'alphapolis',
	'./site/dmzj/api' = 'dmzj',
	'./site/dmzj' = 'dmzj',
	'./site/esjzone' = 'esjzone',
	'./site/hetubook' = 'hetubook',
	'./site/iqing' = 'iqing',
	'./site/kakuyomu' = 'kakuyomu',
	'./site/millionbook' = 'millionbook',
	'./site/novelba' = 'novelba',
	'./site/novelup' = 'novelup',
	'./site/sfacg' = 'sfacg',
	'./site/syosetu' = 'syosetu',
	'./site/uukanshu' = 'uukanshu',
	'./site/webqxs' = 'webqxs',
	'./site/wenku8' = 'wenku8',
	'./site/x23qb' = 'x23qb',
}

export type EnumIDKEYListString = 'alphapolis' | 'dmzj' | 'esjzone' | 'hetubook' | 'iqing' | 'kakuyomu' | 'millionbook' | 'novelba' | 'novelup' | 'sfacg' | 'syosetu' | 'uukanshu' | 'webqxs' | 'wenku8' | 'x23qb';

export enum EnumIDKEYToSiteID
{
	'alphapolis' = 'alphapolis',
	'dmzj' = 'dmzj/api',
	'esjzone' = 'esjzone',
	'hetubook' = 'hetubook',
	'iqing' = 'iqing',
	'kakuyomu' = 'kakuyomu',
	'millionbook' = 'millionbook',
	'novelba' = 'novelba',
	'novelup' = 'novelup',
	'sfacg' = 'sfacg',
	'syosetu' = 'syosetu',
	'uukanshu' = 'uukanshu',
	'webqxs' = 'webqxs',
	'wenku8' = 'wenku8',
	'x23qb' = 'x23qb',
}

export interface INovelSiteList
{
	NovelSiteAlphapolis: typeof import('../site/alphapolis').default
	NovelSiteDemoBase: typeof import('../site/demo/base').default
	NovelSiteDemoDemo: typeof import('../site/demo/demo').default
	NovelSiteDemoTree: typeof import('../site/demo/tree').default
	NovelSiteDmzjApi: typeof import('../site/dmzj/api').default
	NovelSiteDmzj: typeof import('../site/dmzj').default
	NovelSiteEsjzone: typeof import('../site/esjzone').default
	NovelSiteHetubook: typeof import('../site/hetubook').default
	NovelSiteIqing: typeof import('../site/iqing').default
	NovelSiteKakuyomu: typeof import('../site/kakuyomu').default
	NovelSiteMillionbook: typeof import('../site/millionbook').default
	NovelSiteNovelba: typeof import('../site/novelba').default
	NovelSiteNovelup: typeof import('../site/novelup').default
	NovelSiteSfacg: typeof import('../site/sfacg').default
	NovelSiteSyosetu: typeof import('../site/syosetu').default
	NovelSiteUukanshu: typeof import('../site/uukanshu').default
	NovelSiteWebqxs: typeof import('../site/webqxs').default
	NovelSiteWenku8: typeof import('../site/wenku8').default
	NovelSiteX23qb: typeof import('../site/x23qb').default
}